import { orgQueryKeys } from '@/config/queryKeys';
import { adminRoles } from '@/constants';
import { checkAndRedirectForOrgAdminAccess } from '@/helpers';
import { getOrganization } from '@/services/organizations';
import { useAppStore } from '@/stores/app';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/organizations/$orgId')({
  beforeLoad: ({ context, location }) => {
    const store = useAppStore.getState();
    const selectedOrganization = store.selectedOrganization || store.selectedOrgStub;
    checkAndRedirectForOrgAdminAccess({
      context,
      location,
      selectedOrganization,
      adminRoles,
      redirect,
    });
  },
  loader: ({ context: { queryClient }, params: { orgId } }) =>
    queryClient.ensureQueryData({
      queryKey: orgQueryKeys.detail(orgId),
      queryFn: () => getOrganization(orgId),
    }),
});
